import { getApiListById, postApi, putApi } from "../../Shared/Services/RestService";
import { PagedStatsResponse } from "../../Shared/Pagination/PaginationResponse";
import { CompanyInvitationResponse, CompanyInvitationStats, InvitationResponse, UpdateInvitationStatusRequest, UpdateInvitationStatusResponse } from "../Types/InvitationSystemType";


export const createInvitation = (payload: any) => {
  return postApi<InvitationResponse>("/invitations", payload);
};


export const updateInvitationStatus = (payload: UpdateInvitationStatusRequest, id: string) => {
  return putApi<UpdateInvitationStatusResponse | null>("/invitations", id, payload);
};


export interface CompanyInvitationFilters {
  recruiterId?: string;
  fromDate?: string;
  toDate?: string;
  status?: string;
  search?: string;
}

/**
 * Company-wise invitation listing for the recruiter area.
 * `userId` is the current recruiter's user id; the backend resolves the company from it.
 */
export const getCompanyInvitations = (
  userId: string,
  filters: CompanyInvitationFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.recruiterId) params.recruiterId = filters.recruiterId;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.search) params.search = filters.search;
  if (size !== undefined) params.size = size;

  return getApiListById<PagedStatsResponse<CompanyInvitationResponse, CompanyInvitationStats>>(
    "/invitations/company",
    userId,
    params
  );
};